<template>
  <Modal
    sheetbelowsm
    :title="flowType === 'Agent' ? 'Add Agent' : $t('projects.flows.add')"
    :primary-button="$t('save')"
    :primary-button-disabled="!isIntentNameValid()"
    :primary-button-loading="loading"
    :secondary-button="$t('cancel')"
    close-button
    @primary="onSaveClicked"
    @secondary="onCancelClicked"
    @close="onCancelClicked"
  >
    <ValidationObserver ref="validationObserver" v-slot="{ errors }">
      <div class="py-5 w-full sm:w-600 px-10">
        <div class="w-full flex gap-x-6 mb-4">
          <label class="flex items-center gap-x-2 cursor-pointer">
            <input type="radio" v-model="flowType" value="Flow" class="accent-primary" />
            <span class="text-13 font-500">Flow</span>
          </label>
          <label class="flex items-center gap-x-2 cursor-pointer">
            <input type="radio" v-model="flowType" value="Agent" class="accent-primary" />
            <span class="text-13 font-500">Agent</span>
          </label>
        </div>
        <div class="w-full flex mb-3">
          <FormInput v-model="name" name="name" class="w-full" :label="$t('name')" :rules="['required', { validate: isIntentNameValid }]" :error="errors.name"></FormInput>
        </div>
      </div>
    </ValidationObserver>
  </Modal>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { addNewStep } from '@/helpers/flow';
import uuidv4 from '@/helpers/uuid';
import EvaluateItemsConfig from '@/components/flow/evaluate/EvaluateItemsConfig';

export default {
  name: 'CreateProjectFlow',
  data() {
    return {
      originalName: '',
      name: '',
      flowType: 'Flow',
      loading: false,
    };
  },
  computed: {
    ...mapState(['projectData']),
    projectId() {
      return this.$route.params.projectId;
    },
    flowNames() {
      const data = this.projectData?.[this.projectId]?.flows || {};
      return Object.keys(data);
    },
  },
  methods: {
    ...mapActions(['showToastMessage', 'createProjectFlow']),
    isIntentNameValid() {
      if (this.flowNames.includes(this.name)) {
        return this.$t('validation.name_unique');
      }
      return true;
    },
    onCancelClicked() {
      this.$emit('close');
    },
    async onSaveClicked() {
      const valid = await this.$refs.validationObserver.validate();
      if (valid.valid) {
        this.loading = true;

        let response;
        if (this.flowType === 'Agent') {
          const agentItem = {
            ...EvaluateItemsConfig['ai-agent'],
            id: uuidv4(),
            payload: { ...EvaluateItemsConfig['ai-agent'].payload, tools: [] },
          };
          response = await this.createProjectFlow({ project_id: this.projectId, name: this.name, flowType: 'Agent', agent: agentItem });
        } else {
          const steps = [];
          addNewStep(steps, { column: 1 });
          response = await this.createProjectFlow({ project_id: this.projectId, name: this.name, steps, transition: steps[0].id, flowType: 'Flow' });
        }

        if (response) {
          this.$emit('save', { ...response, flowType: this.flowType });
          this.$emit('close');
        }
        this.loading = false;
      }
    },
  },
};
</script>
